import axios from "axios";
import { GET_GAME_HISTORY, GET_GAME_STATS, RESET_COIN } from "./type";
import {
  CLOSE_SPINNER_PROGRESS,
  OPEN_SPINNER_PROGRESS,
} from "../spinner/types";
import { Toast } from "../../util/Toast";

export const getGameHistory =
  (page = 1, limit = 10, startDate = "ALL", endDate = "ALL") =>
  (dispatch) => {
    dispatch({ type: OPEN_SPINNER_PROGRESS });

    axios
      .get("teenpatti/gameHistory/history", {
        params: { page, limit, startDate, endDate },
      })
      .then((res) => {
        console.log("Response:", res.data);
        if (res.data.success) {
          dispatch({
            type: GET_GAME_HISTORY,
            payload: {
              history: res.data.data.history || res.data.data || [],
              pagination: res.data.data.pagination || {
                total: 0,
                page: page,
                limit: limit,
                totalPages: 1,
              },
            },
          });
        }
      })
      .catch((error) => {
        console.error("Axios error:", error);
        Toast("error", "Failed to fetch game history");
      })
      .finally(() => {
        dispatch({ type: CLOSE_SPINNER_PROGRESS });
      });
  };

export const getGameStats =
  (startDate = "ALL", endDate = "ALL") =>
  (dispatch) => {
    axios
      .get("teenpatti/gameHistory/stats", {
        params: { startDate, endDate },
      })
      .then((res) => {
        console.log("Stats Response:", res.data);
        if (res.data.success) {
          dispatch({
            type: GET_GAME_STATS,
            payload: res.data.data.stats || res.data.data,
          });
        }
      })
      .catch((error) => {
        console.error("Axios error:", error);
      });
  };

export const resetGameCoin = () => (dispatch) => {
  axios
    .get("/gameAdminCoin/reset")
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: RESET_COIN, payload: res.data.gameAdminCoin.coin });
        Toast("success", "Admin Diamond Reset Successfully");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error));
};
